jQuery(window).on("scroll", function()
{
    let circleLogo = jQuery("#circle-logo");
    let fullDocumentHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
    );
    circleLogo.css("transform", "rotate(" + ((window.scrollY / fullDocumentHeight) * 720) + "deg)");
});

jQuery("button.read-more").on("click", function()
{
    if (jQuery(this).hasClass("active"))
    {
        jQuery(this).removeClass("active").html("Read more");
        jQuery(this).prev().find(".read-more-text").removeClass("active");
        jQuery(this).prev().find(".ellipsis").removeClass("hidden");
    }
    else
    {
        jQuery(this).addClass("active").html("Read less");
        jQuery(this).prev().find(".read-more-text").addClass("active");
        jQuery(this).prev().find(".ellipsis").addClass("hidden");
    }

});